var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-cta-list',{attrs:{"title":"Köer","subtitle":"Här hittar du köerna för aktuell sajt","headers":_vm.headers,"storeNamespace":"settings","listNamespace":"A_queue","hideTitle":true,"buttonText":"Ny kö","inlineMode":true},scopedSlots:_vm._u([{key:"row.color",fn:function(ref){
var entity = ref.entity;
return [_vm._v(" "+_vm._s(entity.color)+" ")]}},{key:"dialog-content",fn:function(ref){
var setDialog = ref.setDialog;
var dataId = ref.dataId;
return [_c('queue-form',{attrs:{"listOnSave":true,"id":dataId},on:{"requestIsDone":function($event){return setDialog(false)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }